<template>
    <div class="drawer-user-balance">
        <!-- <SessionEndModal /> -->
        <v-list v-if="$auth.loggedIn" dense>
            <!-- <v-list-item to="/profile" class="mb-2">
        <v-list-item-content class="text-center">
          <v-list-item-title class="d-flex align-center justify-center">
            <v-icon color="primary" size="18" class="mr-1"
              >mdi-account-circle</v-icon
            >Profile
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
            <!-- <v-list-item class="mb-2" :class="getClassForCategory()">
        <v-list-item-content>
          <div class="d-flex justify-space-between">
            <div>
              <v-list-item-title
                class="white--text text-center"
                style="font-size: 20px; line-height: 20px"
              >
                {{
                  getUserCategory ? getUserCategory.categoryName : 'Blue'
                }}</v-list-item-title
              >
            </div>
            <div>
              <v-list-item-title
                class="white--text text-center"
                style="font-size: 14px; line-height: 20px"
              >
                <a href="/loyalty" class="view-benefits-btn"
                  >View Benefits
                  <v-icon size="22">mdi-chevron-right</v-icon>
                </a>
              </v-list-item-title>
            </div>
          </div>
        </v-list-item-content>
      </v-list-item> -->
            <!-- <v-list-item class="mb-2">
        <v-list-item-subtitle class="text-center">
          Your Current Program
        </v-list-item-subtitle>
      </v-list-item> -->
            <v-list-item>
                <v-list-item-subtitle class="white--text">
                    Wallet Amount
                    <div class="f8 white--text">(Inclusive bonus)</div>
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{ userBalanceData.balance | currencyFormat }}
                    <div>&nbsp;</div>
                </v-list-item-title>
            </v-list-item>

            <!-- <v-list-item>
        <v-list-item-subtitle>
          Winnings
        </v-list-item-subtitle>
        <v-list-item-title
          :class="{
            'success--text': userBalanceData.winnings > 0,
            'error--text': userBalanceData.winnings < 0
          }"
          class="font-weight-bold body-1"
        >
          {{ userBalanceData.winnings | currencyFormat }}
        </v-list-item-title>
      </v-list-item> -->

            <v-list-item>
                <v-list-item-subtitle class="white--text">
                    Net Exposure
                </v-list-item-subtitle>
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    <!-- :class="{
            'success--text': netExposureData.netExposure > 0,
            'error--text': netExposureData.netExposure < 0
          }" -->
                    <div v-if="netExposureData.netExposure">
                        {{
                            (netExposureData.netExposure / getMyRate())
                                | currencyFormat
                        }}
                    </div>
                    <div v-if="!netExposureData.netExposure">
                        {{ 0 }}
                    </div>
                </v-list-item-title>
            </v-list-item>

            <v-list-item
                v-if="
                    configurationData && configurationData.isNormalBonusWalletOn
                "
            >
                <v-list-item-subtitle class="white--text"
                    >Bonus</v-list-item-subtitle
                >
                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    <div v-if="!user.bonus">0</div>
                    <div v-else>{{ user.bonus | currencyFormat(0) }}</div>
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-subtitle class="white--text"
                    >Available Withdrawal</v-list-item-subtitle
                >

                <v-list-item-title
                    class="font-weight-bold body-1 primary--text"
                >
                    {{
                        userBalanceData.main_balance > 1000
                            ? userBalanceData.main_balance -
                                  user.bonus * limiter.limiter >
                              0
                                ? userBalanceData.main_balance -
                                  user.bonus * limiter.limiter
                                : 0
                            : 0 | toFloor | currencyFormat(0)
                    }}
                </v-list-item-title>
            </v-list-item>
            <!-- <v-list dense> -->
            <!-- </v-list> -->
            <!-- <v-list-item>
        <v-list-item-subtitle>
          Net Wallet Amount
        </v-list-item-subtitle>
        <v-list-item-title class="font-weight-bold body-1 success--text">
          {{
            (((netExposureData.netExposure / getMyRate()) | currencyFormat) +
              userBalanceData.balance)
              | currencyFormat
          }}
        </v-list-item-title>
      </v-list-item> -->
            <!-- <v-list-item v-if="getMyRate() > 1">
        <v-list-item-subtitle>
          Rate
        </v-list-item-subtitle>
        <v-list-item-title class="font-weight-bold caption">
          1 Point = Rs.{{ getMyRate() | currencyFormat(0) }}
        </v-list-item-title>
      </v-list-item> -->
        </v-list>
    </div>
</template>
<script>
// import SessionEndModal from '@/components/SessionEndModal'
// import io from 'socket.io-client'
import { mapState } from "vuex"
import socket from "@/plugins/socket.client"
import socket1 from "@/plugins/newSocket.client.js"
import encryptor from "~/plugins/encryption"
// import service from '@/services/apiService'
export default {
    // components: { SessionEndModal },
    data() {
        return {
            // socket1: io(process.env.userAdminUrl, { reconnection: false }),
            oldAccessToken: localStorage.getItem("accessToken"),
            accessToken: this.$auth.getToken("customLocal"),
            userId: this.$auth.user._id,
            userData: this.$auth.user.currencyType,
            loyaltyProgramShort: [
                {
                    title: "only-blue-bg",
                    color: "white--text",
                    text: "Blue Tier",
                    arrow: "arrow-white"
                }
            ]
        }
    },
    computed: {
        ...mapState({
            configurationData: (state) => state.user.configurationData
        }),
        userBalanceData() {
            return this.$store.state.userBalance.userBalanceData
        },
        netExposureData() {
            return this.$store.state.userBalance.netExposureData
        },
        userDetails() {
            return this.$store.state.profile.data
        },
        getUserCategory() {
            return this.$store.state.wallet.userCategory
        },
        user() {
            return this.$store.state.profile.data
        },
        limiter() {
            return this.$store.state.wallet.limiter
        },
        name() {
            return this.$store.state.profile.data.name
        },
        version() {
            return this.$store.state.profile.appversion
        }
    },
    async created() {
        try {
            if (this.$auth.loggedIn) {
                this.$store.dispatch("profile/getProfile")
                this.$store.dispatch("userBalance/getCurrentBalance")
                // this.$store.dispatch("userBalance/getMemberNetExposure")
                this.$store.dispatch("userBalance/getPendingBonusSum")
                // await this.joinSocketRooms()
                // await this.joinFairplaySocketRooms()
                this.$store.dispatch(
                    "socketMain/joinRoomsForUser",
                    socket.commonSocket.id
                )
                if (localStorage.getItem("accessTokenNewWallet")) {
                    const userId = this.$auth.user._id
                    const abc = localStorage.getItem("accessTokenNewWallet")
                    const jsonToken = JSON.parse(abc)
                    // STEP1: Normal Sockets
                    if (jsonToken && jsonToken._id) {
                        socket.commonSocket.on(
                            "AllSocket_" + jsonToken._id,
                            (eventKeys) => {
                                this.insideSocketFunction(
                                    eventKeys,
                                    jsonToken._id,
                                    jsonToken.accessToken
                                )
                            }
                        )
                        if (jsonToken && jsonToken.sbbonusid) {
                            // STEP2 : Sports Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.sbbonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.sbbonusid,
                                        jsonToken.accessToken_sp
                                    )
                                }
                            )
                        }
                        if (jsonToken && jsonToken.bonusid) {
                            // STEP3 : Bonus Sockets
                            socket.commonSocket.on(
                                "AllSocket_" + jsonToken.bonusid,
                                (eventKeys) => {
                                    this.insideSocketFunction(
                                        eventKeys,
                                        jsonToken.bonusid,
                                        jsonToken.accessToken_bonus
                                    )
                                }
                            )
                        }
                    } else if (jsonToken && !jsonToken._id) {
                        socket.commonSocket.on(
                            "AllSocket_" + userId,
                            (eventKeys) => {
                                if (
                                    eventKeys.eventKey ===
                                        "Balance_" + userId ||
                                    eventKeys.eventKey ===
                                        "balanceWithData_" + userId ||
                                    eventKeys.eventKey ===
                                        "winnerDeclared-fancy-" + userId
                                ) {
                                    this.$store.dispatch(
                                        "userBalance/getCurrentBalance"
                                    )
                                    // this.$store.dispatch("userBalance/getMemberNetExposure")
                                    this.$store.dispatch(
                                        "userBalance/getPendingBonusSum"
                                    )
                                }
                            }
                        )
                    }
                }

                if (
                    localStorage &&
                    localStorage.getItem("getWithdrawalLimit") &&
                    localStorage.getItem("getWithdrawalLimit") !== null
                ) {
                    const limiterSet = JSON.parse(
                        encryptor.decrypt(
                            localStorage.getItem("getWithdrawalLimit")
                        )
                    )
                    this.$store.commit("wallet/set_limiter", limiterSet)
                } else {
                    await this.$store.dispatch("wallet/getWithdrawalLimit")
                    localStorage.setItem(
                        "getWithdrawalLimit",
                        encryptor.encrypt(JSON.stringify(this.limiter))
                    )
                }
                // LOGOUT SOCKET
                socket.commonSocket.on(
                    "AllSocket_" + this.$auth.user._id,
                    (eventKeys) => {
                        if (
                            eventKeys.eventKey ===
                            "logout_" +
                                this.accessToken +
                                "_" +
                                this.$auth.user._id
                        ) {
                            this.$store.dispatch("user/logout")
                            this.$store.commit("snackbar/open", {
                                text: "Your session has ended, please login.",
                                color: "error"
                            })
                        }
                    }
                )
            }
        } catch (error) {}

        // socket.on('Balance_' + this.userId, () => {
        //   // console.log('Balance_', data)
        //   this.$store.dispatch('userBalance/getCurrentBalance')
        //   this.$store.dispatch('userBalance/getMemberNetExposure')
        // })
        // socket.on('balanceWithData_' + this.userId, () => {
        //   // console.log('Balance_', data)
        //   this.$store.dispatch('userBalance/getCurrentBalance')
        //   this.$store.dispatch('userBalance/getMemberNetExposure')
        // })
        // socket.on('winnerDeclared-' + this.userId, () => {
        //   // console.log('demo winner decalred')
        //   this.$store.dispatch('userBalance/getMemberNetExposure')
        // })
        // socket.on('winnerDeclared-fancy-' + this.userId, () => {
        //   this.$store.dispatch('userBalance/getMemberNetExposure')
        // })
        socket.commonSocket.on(
            "logout_" + this.accessToken + "_" + this.userId,
            (data) => {
                // this.$store.commit('userBalance/sessionModal_open')
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            }
        )
        this.$store.dispatch("fairplaySockets/joinRoomLogin", {
            accessToken: this.oldAccessToken,
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        this.$store.dispatch("fairplaySockets/joinBonusRoom", {
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        this.$store.dispatch("fairplaySockets/joinClearUserBonusRoom", {
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        socket1.on(`clearuserdetails-${this.userDetails._id}`, (data) => {
            if (data) {
                if (data.cookieKey && this.$cookies.get(data.cookieKey)) {
                    this.$cookies.set(data.cookieKey, data.cookieKey, "0s")
                }
                if (
                    data.localStrKey &&
                    localStorage.getItem(data.localStrKey)
                ) {
                    localStorage.removeItem(data.localStrKey)
                }
            }
        })
        this.$store.dispatch("fairplaySockets/joinRoomForBlockUser", {
            socket1Id: socket1.id
        })
        const token1 = localStorage.getItem("accessToken")
        socket1.on(`blocked-${token1}`, (data) => {
            this.showSnackbar({
                content: data.message,
                color: "error"
            })
            // this.$router.push("/login")
        })
        socket1.on(`userBonus-${this.userDetails._id}`, (data) => {
            this.$store.dispatch("profile/getProfileForBonusSocket")
        })
        this.$store.dispatch("fairplaySockets/joinRoomForWithdrawal", {
            socket1Id: socket1.id
        })
        socket1.on(
            "logout_" + this.oldAccessToken + "_" + this.userDetails._id,
            (data) => {
                // this.$store.commit('userBalance/sessionModal_open')
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            }
        )
    },
    beforeDestroy() {
        if (this.$auth.loggedIn) {
            socket.commonSocket.off("AllSocket_" + this.$auth.user._id)
        }
        // socket.off('Balance_' + this.userId)
        // socket.off('balanceWithData_' + this.userId)
        // socket.off('winnerDeclared-' + this.userId)
        // socket.off('winnerDeclared-fancy-' + this.userId)
        socket.commonSocket.off(
            "logout_" + this.accessToken + "_" + this.userId
        )
        socket1.off(
            "logout_" + this.oldAccessToken + "_" + this.userDetails._id
        )
        this.$store.dispatch("fairplaySockets/leaveRoomLogin", {
            accessToken: this.oldAccessToken,
            userId: this.userDetails._id,
            socket1Id: socket1.id
        })
        socket1.off(`clearuserdetails-${this.userDetails._id}`)
        socket1.off(`sendNotificationToUser-${this.userId}`)
    },
    methods: {
        showSnackbar({ content, color }) {
            this.$store.commit("snackbar/open", {
                text: content,
                color
            })
        },
        insideSocketFunction(eventKeys, userId, accessToken) {
            if (
                eventKeys.eventKey === "Balance_" + userId ||
                eventKeys.eventKey === "balanceWithData_" + userId ||
                eventKeys.eventKey === "winnerDeclared-fancy-" + userId
            ) {
                console.log(
                    "eventKeys, userId, accessToken",
                    eventKeys,
                    userId,
                    accessToken
                )
                this.$store.dispatch("userBalance/getCurrentBalance")
                // this.$store.dispatch("userBalance/getMemberNetExposure")
                this.$store.dispatch("userBalance/getPendingBonusSum")
            } else if (
                eventKeys.eventKey ===
                "logout_" + accessToken + "_" + userId
            ) {
                this.$store.dispatch("user/logout")
                this.$store.commit("snackbar/open", {
                    text: "Your session has ended, please login.",
                    color: "error"
                })
            } else if (eventKeys.eventKey === "Rt_Invalidation_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
            } else if (eventKeys.eventKey === "BetCancelled_" + userId) {
                this.$store.commit("snackbar/open", {
                    text: eventKeys.message,
                    color: "error"
                })
                this.$store.dispatch("openBets/getMyCurrentBetStatus", false)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.drawer-user-balance {
    .v-list-item__subtitle {
        flex: 1 1 100%;
        overflow: hidden;
        text-overflow: unset !important;
        white-space: unset !important;
    }
}
.view-benefits-btn {
    color: $white !important;
    text-decoration: none;
}
.view-benefits-btn .v-icon {
    margin-left: -4px;
    color: $white !important;
}
.view-benefits-btn:hover,
.view-benefits-btn:hover .v-icon {
    color: $black !important;
}
</style>
